import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { TokenPlanInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialPlan: Partial<TokenPlanInterface> = {
  price: 0,
  notes: '',
  tokensInThisPackage: 0,
  active: true,
};

const AdSpaceTokenPlansAdminAddTokenPlanPage: React.FC = () => {
  const [plan, setPlan] = useState<Partial<TokenPlanInterface>>(initialPlan);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof TokenPlanInterface, value: any) => {
    setPlan(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<TokenPlanInterface>>('/tokenPlans/insert', 'POST', plan);
      if (result.status) {
        setSuccess(result.message || 'Token plan created successfully!');
        setDialogOpen(true);
        setPlan(initialPlan);
      } else {
        setError(result.message || 'Failed to create token plan');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create token plan');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Token Plan</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Price"
          type="number"
          value={plan.price ?? ''}
          onChange={e => handleChange('price', Number(e.target.value))}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Notes"
          value={plan.notes ?? ''}
          onChange={e => handleChange('notes', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Tokens in Package"
          type="number"
          value={plan.tokensInThisPackage ?? ''}
          onChange={e => handleChange('tokensInThisPackage', Number(e.target.value))}
          fullWidth
          margin="dense"
          required
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={plan.active !== undefined ? (plan.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Token Plan
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdSpaceTokenPlansAdminAddTokenPlanPage;